import React, { useEffect, useState } from "react";
import { baseRequest } from "../../../axiosconfig";

function ArchiveMapeProcesa(props) {
  const [processMaps, setProcessMaps] = useState(null);

  const headerTitles = [
    { id: 0, title: "Šifra procesa", width: "10%" },
    { id: 1, title: "Poslovni proces", width: "23%" },
    { id: 2, title: "Vlasnik procesa", width: "23%" },
    { id: 3, title: "Odobrio", width: "20%" },
    { id: 4, title: "Verzija", width: "8%" },
    { id: 5, title: "Datum", width: "16%" },
  ];

  useEffect(() => {
    baseRequest
      .get("/process_maps")
      .then((res) => {
        if (res.data.process_maps) {
          // arhiva prikazuje isključivo arhivirane, neobrisane mape
          setProcessMaps(
            res.data.process_maps.filter((m) => m.is_archived && !m.del)
          );
        }
      })
      .catch((error) => { console.error("Failed to fetch process maps:", error); });
  }, []);

  const owners = (map) =>
    (map.business_process_list?.business_process_owners || [])
      .filter((o) => !o.del)
      .map((o) => `${o.first_name || ""} ${o.last_name || ""}`.trim())
      .filter(Boolean)
      .join(", ");

  const approvedBy = (map) =>
    map.approved_by
      ? `${map.approved_by.first_name || ""} ${map.approved_by.last_name || ""}`.trim()
      : "";

  const mapDate = (map) => {
    const d = map.verified_at || map.approved_at || map.created_at;
    return d ? new Date(d).toLocaleDateString("sr-RS") : "";
  };

  return (
    <div className="table-scroll">
      <ul
        className="registri-header "
        style={{
          borderLeft: "var(--mainBorder)",
          borderRight: "var(--mainBorder)",
          borderBottom: "var(--mainBorder)",
        }}
      >
        {headerTitles.map((item) => (
          <li
            key={item.id}
            className="registri-header-cell"
            style={{ width: item.width ? item.width : "auto" }}
          >
            {item.title}
          </li>
        ))}
      </ul>
      {processMaps && processMaps.length === 0 && (
        <p style={{ color: "var(--mainColor)", padding: "20px" }}>
          Nema arhiviranih mapa procesa.
        </p>
      )}
      {(processMaps || []).map((map) => (
        <ul
          key={map.id}
          className="registri-header"
          style={{
            borderLeft: "var(--mainBorder)",
            borderRight: "var(--mainBorder)",
            borderBottom: "var(--mainBorder)",
          }}
        >
          <li className="registri-header-cell" style={{ width: "10%" }}>
            {map.business_process_list?.code || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "23%" }}>
            {map.business_process_list?.name || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "23%" }}>
            {owners(map)}
          </li>
          <li className="registri-header-cell" style={{ width: "20%" }}>
            {approvedBy(map)}
          </li>
          <li className="registri-header-cell" style={{ width: "8%" }}>
            {map.version || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "16%" }}>
            {mapDate(map)}
          </li>
        </ul>
      ))}
    </div>
  );
}

export default ArchiveMapeProcesa;
